import olms, {apply, applyBackground, applyStyle} from './index';
import stylefunction from './stylefunction';
import {assign} from './util';

assign(olms, {apply, applyBackground, applyStyle, stylefunction});

export default olms;
